export default {
  title: {
    en: 'Welcome back',
  },
  subTitle: {
    en: 'You’ve selected a Premium Product this month.',
  },
  text: {
    en: 'This high-end and limited product costs an additional $10, which you’ll see reflected on your account.',
  },
  hint: {
    en: 'Your subscription order is processing now.',
  },
}
